import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { getDatePlusDays } from 'utils';
import { DomId } from 'constants/DomId';

import { IHelpSection } from '../models';
import HelpMultiItemSearch from '../sections/HelpMultiItemSearch';
import HelpGeneralPDP from '../sections/HelpGeneralPDP';
import HelpGeneralPLP from '../sections/HelpGeneralPLP';
import HelpCustomizingViews from '../sections/HelpCustomizingViews';
import HelpAdvancedSearch from '../sections/HelpAdvancedSearch';
import HelpAvailability from '../sections/HelpAvailability';
import HelpImages from '../sections/HelpImages';
import HelpSources from '../sections/HelpSources';

import messages from './messages';

const MAX_DAYS_NEW = 60;

export const useHelpSections = () => {
  const { formatMessage } = useIntl();

  const sections = useMemo(
    (): IHelpSection[] => [
      {
        content: <HelpGeneralPLP />,
        label: formatMessage(messages.helpGeneralPLP),
        hash: DomId.HelpGeneralPLP,
        dateAdded: new Date('2023/10/01'),
      },
      {
        content: <HelpMultiItemSearch />,
        label: formatMessage(messages.helpMultiItemSearch),
        hash: DomId.HelpMultiItemSearch,
        dateAdded: new Date('2023/12/15'),
      },
      {
        content: <HelpAdvancedSearch />,
        label: formatMessage(messages.helpAdvancedSearch),
        hash: DomId.HelpAdvancedSearch,
        dateAdded: new Date('2023/10/01'),
      },
      {
        content: <HelpGeneralPDP />,
        label: formatMessage(messages.helpGeneralPDP),
        hash: DomId.HelpGeneralPDP,
        dateAdded: new Date('2023/10/01'),
      },
      {
        content: <HelpAvailability />,
        label: formatMessage(messages.helpAvailability),
        hash: DomId.HelpAvailability,
        dateAdded: new Date('2023/10/01'),
      },
      {
        content: <HelpImages />,
        label: formatMessage(messages.helpImages),
        hash: DomId.HelpImages,
        dateAdded: new Date('2023/10/01'),
      },
      {
        content: <HelpSources />,
        label: formatMessage(messages.helpSources),
        hash: DomId.HelpSources,
        dateAdded: new Date('2023/10/01'),
      },
      {
        content: <HelpCustomizingViews />,
        label: formatMessage(messages.helpCustomizingViews),
        hash: DomId.HelpCustomizingViews,
        dateAdded: new Date('2023/10/01'),
      },
    ],
    [formatMessage]
  );

  const isSectionNew = useCallback((section: IHelpSection) => {
    const today = new Date();
    return (
      getDatePlusDays(section.dateAdded, MAX_DAYS_NEW).getTime() >
      today.getTime()
    );
  }, []);

  return { sections, isSectionNew };
};
